import React, { createContext } from 'react';

import { OptimizeConfig } from './optimize-types';

export interface IOptimizeropsContext {
    optimizeConfig: OptimizeConfig;
};

const OptimizeContext = createContext<IOptimizeropsContext | null>(null);

type OptimizeProps = {
    config: OptimizeConfig;
};

const Optimize: React.FC<OptimizeProps> = ({ config: optimizeConfig, children }) => (
    <OptimizeContext.Provider value={{ optimizeConfig }}>
        { children }
    </OptimizeContext.Provider>
);

export default Optimize;

export {
    OptimizeContext,
};